import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO } from '../data/company';

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 - Siden blev ikke fundet · JNO Montage</title>
      </Helmet>

      <section className="py-24 bg-[#E6EBEF] min-h-[70vh] flex items-center justify-center px-4">
        <div className="max-w-xl mx-auto bg-white p-8 sm:p-12 rounded-3xl border border-gray-200 shadow-xl text-center space-y-6">
          <div className="w-20 h-20 bg-[#206FEA]/10 text-[#206FEA] rounded-full flex items-center justify-center mx-auto text-3xl">
            <i className="fa-solid fa-triangle-exclamation text-[#206FEA]" aria-hidden="true"></i>
          </div>

          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-widest text-[#206FEA]">Fejl 404</span>
            <h1 className="text-3xl font-extrabold text-[#0B0E14]">Siden blev ikke fundet</h1>
            <p className="text-sm text-slate-600">
              Beklager, den side du leder efter findes ikke eller er blevet flyttet. Brug gerne et af de følgende links til at komme videre.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2 text-sm font-semibold">
            <Link
              to="/"
              className="p-3 bg-[#0B0E14] text-white rounded-xl hover:bg-[#192330] transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-house" aria-hidden="true"></i>
              <span>Forside</span>
            </Link>

            <Link
              to="/ydelser"
              className="p-3 bg-[#E6EBEF] text-[#0B0E14] border border-gray-200 rounded-xl hover:border-[#206FEA] transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-screwdriver-wrench" aria-hidden="true"></i>
              <span>Vores Ydelser</span>
            </Link>

            <Link
              to="/prisberegner"
              className="p-3 bg-[#E6EBEF] text-[#0B0E14] border border-gray-200 rounded-xl hover:border-[#206FEA] transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-calculator" aria-hidden="true"></i>
              <span>Prisberegner</span>
            </Link>

            <Link
              to="/kontakt"
              className="p-3 bg-[#E6EBEF] text-[#0B0E14] border border-gray-200 rounded-xl hover:border-[#206FEA] transition-colors flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-envelope" aria-hidden="true"></i>
              <span>Kontakt</span>
            </Link>
          </div>

          <div className="pt-4 border-t border-gray-100 text-xs text-slate-600">
            <span>Har du brug for hjælp? Ring direkte til os på </span>
            <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-extrabold text-[#206FEA] hover:underline whitespace-nowrap">
              {COMPANY_INFO.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
